<template>
  <modal
    class="custom-report-deleter text-left"
    :append-to-body="true"
    v-model="shown"
    :title="'Delete ' + ((group.name || '').length > 0 ? group.name : 'Untitled Report') + '?'"
  >
    <div style="width: 100%">
      <p class="text-big">
        Are you sure you want to delete the custom report

        <span style="white-space: nowrap">'{{ group.name }}'?</span>
      </p>

      <p class="text-danger text-left" v-for="error in errors" v-bind:key="error">{{ error }}</p>
    </div>

    <template #footer>
      <div>
        <button class="btn btn-primary btn-lg" @click="doDelete()" type="button">Delete</button>

        <button class="btn btn-default btn-lg" @click="cancel()" type="button">Cancel</button>
      </div>
    </template>
  </modal>
</template>

<script setup lang="ts">
import { ref } from "vue";
import axios from "axios";
import { Modal } from "uiv";

import { CustomReportApiModel } from "../api-models";

const props = defineProps<{
  group: CustomReportApiModel;
  deleteUrlBase: string;
}>();

const emit = defineEmits(["dialog-closed", "dialog-opened", "deleted"]);

const errors = ref<string[]>([]);

const shown = ref(false);

function close(): void {
  shown.value = false;
  setTimeout(() => {
    emit("dialog-closed");
  }, 1000);
}

function cancel(): void {
  close();
}

function open(): void {
  setTimeout(() => {
    shown.value = true;
  }, 200);
  emit("dialog-opened");
}

function doDelete(): void {
  axios
    .delete(`${props.deleteUrlBase}/${props.group.id}`.replace("//", "/"))
    .then(() => {
      errors.value = [];
      close();
      emit("deleted");
    })
    .catch(() => {
      errors.value = ["There was a problem. Please check your internet connection and try again."];
    });
}

const getGroup = (): CustomReportApiModel => {
  return props.group;
};

defineExpose({
  open,
  close,
  cancel,
  getGroup,
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import (reference) "../styles/bootstrap/bootstrap.less";
// .custom-report-deleter {

// }
</style>
